<template lang="pug">
.container.bg-white.rounded-bottom
  .row(style="background-color: #f3f1ed;")
    .col
      radar-chart.my-5(
        v-if="!isLoading"
        ref="chart"
        :chart-data="analysis"
        :options="options"
      )
  .row
    .col.bg-blue.rounded-top.py-2
      .d-flex.justify-content-center
        span.text-white.h3
          | {{ material }}
  .row.border-dark.py-4
    .col-md-3.d-flex.justify-content-center
      font-awesome-icon(icon="calendar-minus" size="lg").mr-2
      | {{ createdAt }}
    .col-md-3.d-flex.justify-content-center
      font-awesome-icon(icon="user" size="lg").mr-2
      | {{ name.consultant }}
    .col-md-3.d-flex.justify-content-center
      font-awesome-icon(icon="users" size="lg").mr-2
      | {{ name.vip }}
    .col-md-3.d-flex.justify-content-center
      font-awesome-icon(icon="chart-line" size="lg").mr-2
      | Lv. {{ averageLevel }}
  .row
    .col
      .accordion(role="tablist")
        comment(
          title="Vocabulary"
          :level="level.vocabulary"
          :comment="{ customize: comment.vocabulary }"
        )
        comment(
          title="Listening"
          :level="level.listening"
          :comment="{ customize: comment.listening }"
        )
        comment(
          title="Grammar"
          :level="level.grammar"
          :comment="{ customize: comment.grammar }"
        )
        comment(
          title="Speaking"
          :level="level.speaking"
          :comment="{ customize: comment.speaking }"
        )
        comment(
          title="Reading"
          :level="level.reading"
          :comment="{ customize: comment.reading }"
        )
        comment(
          title="Pronunciation"
          :level="level.pronunciation"
          :comment="{ customize: comment.pronunciation }"
        )
</template>

<script>
import { getApiBaseURL } from '@/utils/api-helper';
import Comment from '@/components/memberClassRecords/viewAnalysis/comment/index.vue';
import RadarChart from '@/components/memberClassRecords/viewAnalysis/radarChart/index.vue';

import api, { Platform } from '@lioshutan/api-package';

export default {
  components: {
    Comment,
    RadarChart,
  },
  data: () => ({
    isLoading: false,
    token: null,
    averageLevel: 0,
    createdAt: null,
    material: '',
    name: {
      vip: '',
      consultant: '',
    },
    comment: {
      vocabulary: '',
      listening: '',
      grammar: '',
      speaking: '',
      reading: '',
      pronunciation: '',
    },
    level: {
      vocabulary: 0,
      listening: 0,
      grammar: 0,
      speaking: 0,
      reading: 0,
      pronunciation: 0,
    },
    analysis: null,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 0,
      },
      responsiveAnimationDuration: 0,
      scale: {
        ticks: {
          min: 1,
          max: 12,
        },
        pointLabels: {
          fontSize: 16,
          fontFamily: 'Noto Sans TC,sans-serif',
        },
      },
      legend: {
        labels: {
          fontSize: 16,
          fontFamily: 'Noto Sans TC,sans-serif',
        },
      },
    },
  }),
  async created() {
    const loading = this.$loading.show();
    this.isLoading = true;
    this.token = this.$store.state.auth.token;
    const {
      data: {
        vipAnalysis,
      },
    } = await api
      .setDNS(getApiBaseURL())
      .analysis(this.token)
      .getStudentAnalysis({
        platform: Platform.WUWOW_JUNIOR,
        vipId: this.$route.query.vipId,
        classApplicationId: this.$route.query.caId,
      });

    this.analysis = {
      labels: [
        'Vocabulary',
        'Grammar',
        'Listening',
        'Speaking',
        'Reading',
        'Pronunciation',
      ],
      datasets: [
        {
          data: [
            vipAnalysis.vocabularyLevel,
            vipAnalysis.grammarLevel,
            vipAnalysis.listeningLevel,
            vipAnalysis.speakingLevel,
            vipAnalysis.readingLevel,
            vipAnalysis.pronunciationLevel,
          ],
          label: 'level',
          backgroundColor: '#4085c0',
        },
      ],
    };

    this.material = vipAnalysis.material.title;

    this.name.vip = vipAnalysis.vip.englishName;
    this.name.consultant = vipAnalysis.consultant.englishName;

    this.comment.vocabulary = vipAnalysis.suggestionOfVocabulary;
    this.comment.listening = vipAnalysis.suggestionOfListening;
    this.comment.grammar = vipAnalysis.suggestionOfGrammar;
    this.comment.speaking = vipAnalysis.suggestionOfSpeaking;
    this.comment.reading = vipAnalysis.suggestionOfReading;
    this.comment.pronunciation = vipAnalysis.suggestionOfPronunciation;

    this.level.vocabulary = vipAnalysis.vocabularyLevel;
    this.level.grammar = vipAnalysis.grammarLevel;
    this.level.listening = vipAnalysis.listeningLevel;
    this.level.speaking = vipAnalysis.speakingLevel;
    this.level.reading = vipAnalysis.readingLevel;
    this.level.pronunciation = vipAnalysis.pronunciationLevel;

    this.averageLevel = vipAnalysis.averageLevel;
    this.createdAt = vipAnalysis.createdAt;
    loading.hide();
    this.isLoading = false;
  },
};
</script>
